<template>
  <v-container>
    <v-row justify="center" class="param-area">
      <v-col cols="10" xs="10" sm="8" md="8" lg="8">
        <TitleLabel :title="title" />
      </v-col>
    </v-row>
    <v-row justify="center" class="check_list-area">
      <CheckListSwitch v-if="false" />
      <v-col
        cols="12"
        xs="12"
        sm="6"
        md="6"
        lg="6"
        v-if="isShownGoodList"
        class="check_list"
      >
        <v-row>
          <CheckListTitle :title="goodListTitle" />
          <v-btn text @click="switchToBad" v-if="isUsingDevice === 'sp'">
            <p class="switch-text">悪い行い</p>
          </v-btn>
        </v-row>
        <CheckList
          :user-authority="userAuthority"
          :is-under-editing="isUnderEditing"
          action-type="GOOD"
          :eco-items.sync="goodEcoItems"
          :checked-eco-item-ids="checkedEcoItemIds"
          @deleteItem="deleteItem($event, 'GOOD')"
          @checkItem="checkItem($event, 'GOOD')"
        />
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="6"
        md="6"
        lg="6"
        v-if="isShownBadList"
        class="check_list"
      >
        <v-row>
          <v-btn text @click="switchToGood" v-if="isUsingDevice === 'sp'">
            <p class="switch-text">良い行い</p>
          </v-btn>
          <CheckListTitle :title="badListTitle" />
        </v-row>
        <CheckList
          :user-authority="userAuthority"
          :is-under-editing="isUnderEditing"
          action-type="BAD"
          :eco-items.sync="badEcoItems"
          :checked-eco-item-ids="checkedEcoItemIds"
          @deleteItem="deleteItem($event, 'BAD')"
          @checkItem="checkItem($event, 'BAD')"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        cols="5"
        xs="5"
        sm="5"
        md="2"
        lg="2"
        v-if="userAuthority === 'MAINTAINER'"
      >
        <NormalSimpleButton
          button-title="採点する"
          @clickAction="startScoringAction"
        />
      </v-col>
      <v-col cols="5" xs="5" sm="5" md="2" lg="2">
        <NormalSimpleBlackButton
          button-title="完了する"
          @clickAction="doneEditingAction"
          v-if="userAuthority === 'MANAGER' && isUnderEditing"
        />
        <NormalSimpleButton
          button-title="編集する"
          @clickAction="startEditAction"
          v-if="userAuthority === 'MANAGER' && !isUnderEditing"
        />
        <NormalSimpleButton
          button-title="項目を追加する"
          @clickAction="addListItemAction"
          v-if="userAuthority === 'MAINTAINER'"
        />
      </v-col>
    </v-row>
    <v-col cols="12" xs="12" sm="10" md="10" lg="8">
      <v-overlay absolute :value="editOverlay" color="rgba(0,0,0,0)">
        <Dialog
          @negativeAction="closeDialog"
          @positiveAction="editAction"
          dialog-text="編集を完了しますか？"
          :device="isUsingDevice"
        />
      </v-overlay>
      <v-overlay absolute :value="scoringOverlay" color="rgba(0,0,0,0)">
        <Dialog
          @negativeAction="closeDialog"
          @positiveAction="scoringAction"
          dialog-text="今日のポイントを採点しますか？"
          :device="isUsingDevice"
        />
      </v-overlay>
    </v-col>
  </v-container>
</template>

<script>
import TitleLabel from "../Atoms/TitleLabel";
import CheckListTitle from "../Atoms/CheckListTitle";
import CheckListSwitch from "../Molecules/CheckListSwitch";
import CheckList from "../Organisms/CheckList";
import NormalSimpleButton from "../Atoms/NormalSimpleButton";
import NormalSimpleBlackButton from "../Atoms/NormalSimpleBlackButton";
import Dialog from "../Molecules/Dialog";
import errorHandle from "../../util/errorHandle.js";

export default {
  name: "Check",
  data: () => ({
    accessToken: "",
    userAuthority: "",
    isUnderEditing: false,
    editOverlay: false,
    scoringOverlay: false,
    title: "今日やったことに\nチェックをつけよう！",
    selectedList: "good",
    goodEcoItems: [],
    goodOriginEcoItems: [],
    badEcoItems: [],
    badOriginEcoItems: [],
    doneEcos: [],
    originCheckedEcoItems: [],
    checkedEcoItemIds: []
  }),
  created() {
    this.fetchInitialData();
    this.getCheckItem();
    this.insertOriginCheckedEcoItems();
    this.initCheckedItem();
  },
  mounted() {
    this.initIcon();
    this.getInitialGoodEcoItems();
    this.getInitialBadEcoItems();
  },
  methods: {
    // API通信を行うのに必要な情報を取得する
    fetchInitialData() {
      const user_info = this.$store.getters["user/getUserInfo"];
      this.accessToken = user_info.accessToken;
      this.userId = user_info.userId;
      this.userAuthority = user_info.userAuthority;
    },
    // 本日チェックしているアイテムに関しては事前にチェックしておく
    initCheckedItem() {
      const header = {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
      this.axios
        .get(`/api/done_ecos?user_id=${this.userId}`, header)
        .then(response => {
          this.doneEcos = response.data.done_ecos;
          for (let doneEco of this.doneEcos) {
            this.checkedEcoItemIds.push(doneEco.eco_item_id);
          }
        })
        .catch(error => {
          errorHandle
            .errorHandle(this, error)
            .then(() => {
              this.initCheckedItem();
            })
            .catch(function(error) {
              console.log("エラーハンドリング失敗。エラー内容：", error);
            });
          console.log(error);
        });
    },
    // 採点時に比較できるように初期値を記憶しておく
    insertOriginCheckedEcoItems() {
      const header = {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
      this.axios
        .get(`/api/done_ecos?user_id=${this.userId}`, header)
        .then(response => {
          let doneEcos = response.data.done_ecos;
          for (let doneEco of doneEcos) {
            this.originCheckedEcoItems.push(doneEco.eco_item_id);
          }
        })
        .catch(error => {
          errorHandle
            .errorHandle(this, error)
            .then(() => {
              this.insertOriginCheckedEcoItems();
            })
            .catch(function(error) {
              console.log("エラーハンドリング失敗。エラー内容：", error);
            });
          console.log(error);
        });
    },
    // チェックぼっくすがチェックされた時に実行される関数
    checkItem(index, actionType) {
      let itemId = 0;
      switch (actionType) {
        case "GOOD":
          itemId = this.goodEcoItems[index].id;
          // 既に配列内にitemIdがある場合は削除
          if (this.checkedEcoItemIds.includes(itemId)) {
            let deleteIndex = this.checkedEcoItemIds.indexOf(itemId);
            this.checkedEcoItemIds.splice(deleteIndex, 1);
          } else {
            this.checkedEcoItemIds.push(itemId);
          }
          break;
        case "BAD":
          itemId = this.badEcoItems[index].id;
          // 既に配列内にitemIdがある場合は削除
          if (this.checkedEcoItemIds.includes(itemId)) {
            let deleteIndex = this.checkedEcoItemIds.indexOf(itemId);
            this.checkedEcoItemIds.splice(deleteIndex, 1);
          } else {
            this.checkedEcoItemIds.push(itemId);
          }
          break;
      }
    },
    scoringAction() {
      let deleteItemArray = [];
      let postItemArray = [];

      // 削除すべきIdを決定する
      for (let originItem of this.originCheckedEcoItems) {
        if (this.checkedEcoItemIds.includes(originItem)) {
          continue;
        } else {
          // そのままeco_item_idを入れるのではなく、done_ecosテーブルのidを格納する
          for (let doneEco of this.doneEcos) {
            if (doneEco.eco_item_id === originItem) {
              deleteItemArray.push(doneEco.id);
            }
          }
        }
      }
      // 投稿すべきIdを決定する
      for (let checkedEcoItemId of this.checkedEcoItemIds) {
        if (this.originCheckedEcoItems.includes(checkedEcoItemId)) {
          continue;
        } else {
          postItemArray.push(checkedEcoItemId);
        }
      }

      if (deleteItemArray.length > 0 && postItemArray.length > 0) {
        this.postDoneEcoIds(postItemArray).then(() => {
          for (let deleteItem of deleteItemArray) {
            this.deleteDoneEcoIds(deleteItem);
          }
          this.$router.push("point");
        });
      } else if (deleteItemArray.length > 0) {
        for (let deleteItem of deleteItemArray) {
          this.deleteDoneEcoIds(deleteItem);
        }
        this.$router.push("point");
      } else if (postItemArray.length > 0) {
        this.postDoneEcoIds(postItemArray).then(() => {
          this.$router.push("point");
        });
      } else {
        alert(
          "新しい内容がありません。内容を編集をしてから「採点する」ボタンを押してください。"
        );
      }
    },
    postDoneEcoIds(postItemArray) {
      return new Promise((resolve, reject) => {
        const postDoneEcoIds = {
          eco_item_ids: postItemArray
        };
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        this.axios
          .post("/api/done_ecos", postDoneEcoIds, header)
          .then(response => {
            console.log("エコ項目のdoneItemPostのresponse", response);
            resolve();
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.postDoneEcoIds;
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
                reject();
              });
            console.log(error);
          });
      });
    },
    deleteDoneEcoIds(id) {
      return new Promise((resolve, reject) => {
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        this.axios
          .delete(`/api/done_ecos/${id}`, header)
          .then(response => {
            console.log("エコ項目のdeleteItemPostのresponse", response);
            resolve();
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.postDoneEcoIds;
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
                reject;
              });
            console.log(error);
          });
      });
    },
    addListItemAction() {
      this.$router.push("addItem");
    },
    startEditAction() {
      this.isUnderEditing = !this.isUnderEditing;
    },
    doneEditingAction() {
      this.editOverlay = !this.editOverlay;
    },
    startScoringAction() {
      this.scoringOverlay = !this.scoringOverlay;
    },
    closeDialog() {
      this.editOverlay = false;
      this.scoringOverlay = false;
    },
    editAction() {
      this.edit("GOOD", this.goodEcoItems, this.goodOriginEcoItems);
      this.edit("BAD", this.badEcoItems, this.badOriginEcoItems);
      this.isUnderEditing = !this.isUnderEditing;
      this.editOverlay = !this.editOverlay;
      this.getCheckItem();
    },
    edit(actionType, Items, originItems) {
      for (let item of Items) {
        if (!item.id) {
          // idの無いものはpostする
          item.action_type = actionType;
          if (!item.name) {
            alert("項目内容は必須です");
            return;
          }
          if (!item.reason) {
            alert("理由欄は必須です");
            return;
          }
          this.postEcoItem(item);
        } else {
          for (let originEcoItem of originItems) {
            if (item.id === originEcoItem.id) {
              const item_id = item.id;
              delete item["action_type"];
              delete item["created_at"];
              delete item["id"];
              delete item["updated_at"];

              if (item.name === originEcoItem.name) {
                delete item["name"];
              }
              if (item.earth_impact_type === originEcoItem.earth_impact_type) {
                delete item["earth_impact_type"];
              }
              if (item.point === originEcoItem.point) {
                delete item["point"];
              }
              if (item.reason === originEcoItem.reason) {
                delete item["reason"];
              }

              var goodItemLen = Object.keys(item);
              if (!goodItemLen.length) {
                continue;
              } else {
                console.log("一致しなかったgoodItem", item);
                this.putEcoItem(item, item_id);
              }
            }
          }
        }
      }
      this.overlay = !this.overlay;
    },
    initIcon() {
      this.$emit("initIcon");
    },
    getCheckItem() {
      return new Promise((resolve, reject) => {
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        // GOODのエコ項目を入れる
        this.axios
          .get("/api/eco_items?action_type=GOOD", header)
          .then(response => {
            this.goodEcoItems = response.data.eco_items;
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.getCheckItem();
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
              });
            console.log(error);
            reject();
          });
        // BADのエコ項目を入れる
        this.axios
          .get("/api/eco_items?action_type=BAD", header)
          .then(response => {
            this.badEcoItems = response.data.eco_items;
            this.badOriginEcoItems = response.data.eco_items;
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.getCheckItem();
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
              });
            console.log(error);
            reject();
          });
      });
    },
    deleteItem(index, actionType) {
      var result = confirm("本当にこの項目を削除しますか？");
      if (result) {
        this.delete(index, result, actionType);
      }
    },
    delete(index, result, actionType) {
      const header = {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
      let itemId = 0;
      switch (actionType) {
        case "GOOD":
          itemId = this.goodEcoItems[index].id;
          break;
        case "BAD":
          itemId = this.badEcoItems[index].id;
          break;
      }
      if (!itemId) {
        switch (actionType) {
          case "GOOD":
            this.goodEcoItems.splice(index, 1);
            break;
          case "BAD":
            this.badEcoItems.splice(index, 1);
            break;
        }
      }
      this.axios
        .delete("/api/eco_items/" + itemId, header)
        .then(response => {
          console.log("エコ項目のdeleteのresponse", response);
          switch (actionType) {
            case "GOOD":
              this.goodEcoItems.splice(index, 1);
              break;
            case "BAD":
              this.badEcoItems.splice(index, 1);
              break;
          }
        })
        .catch(error => {
          errorHandle
            .errorHandle(this, error)
            .then(() => {
              this.getInitialGoodEcoItems();
            })
            .catch(function(error) {
              console.log("エラーハンドリング失敗。エラー内容：", error);
            });
          console.log(error);
        });
    },
    getInitialGoodEcoItems() {
      return new Promise((resolve, reject) => {
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        // GOODのエコ項目を入れる
        this.axios
          .get("/api/eco_items?action_type=GOOD", header)
          .then(response => {
            this.goodOriginEcoItems = response.data.eco_items;
            resolve();
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.getInitialGoodEcoItems();
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
              });
            console.log(error);
            reject();
          });
      });
    },
    getInitialBadEcoItems() {
      return new Promise((resolve, reject) => {
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        // BADのエコ項目を入れる
        this.axios
          .get("/api/eco_items?action_type=BAD", header)
          .then(response => {
            this.badOriginEcoItems = response.data.eco_items;
            resolve();
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.getInitialBadEcoItems();
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
              });
            console.log(error);
            reject();
          });
      });
    },
    postEcoItem(data) {
      const header = {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
      this.axios
        .post("/api/eco_items", data, header)
        .then(response => {
          console.log("エコ項目のpostのresponse", response);
        })
        .catch(error => {
          errorHandle
            .errorHandle(this, error)
            .then(() => {
              this.postEcoItem(data);
            })
            .catch(function(error) {
              console.log("エラーハンドリング失敗。エラー内容：", error);
            });
          console.log(error);
        });
    },
    putEcoItem(data, item_id) {
      console.log("item_id", item_id);
      const header = {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
      this.axios
        .put("/api/eco_items/" + item_id, data, header)
        .then(response => {
          console.log("エコ項目のputのresponse", response);
        })
        .catch(error => {
          errorHandle
            .errorHandle(this, error)
            .then(() => {
              this.putEcoItem(data);
            })
            .catch(function(error) {
              console.log("エラーハンドリング失敗。エラー内容：", error);
            });
          console.log(error);
        });
    },
    switchToBad() {
      console.log("switchToBad");
      this.selectedList = "bad";
    },
    switchToGood() {
      console.log("switchToGood");
      this.selectedList = "good";
    }
  },
  computed: {
    // 「使用画面 -> スマホ」&&「選択されたリスト -> 悪い行い」の場合のみ非表示
    isShownGoodList() {
      if (this.isUsingDevice === "pc") {
        return true;
      } else {
        if (this.selectedList === "good") {
          return true;
        } else {
          return false;
        }
      }
    },
    // 「使用画面 -> スマホ」&&「選択されたリスト -> 良い行い」の場合のみ非表示
    isShownBadList() {
      if (this.isUsingDevice === "pc") {
        return true;
      } else {
        if (this.selectedList === "bad") {
          return true;
        } else {
          return false;
        }
      }
    },
    isUsingDevice() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "sp";
        case "sm":
        case "md":
        case "lg":
        case "xl":
          return "pc";
        default:
          return "none";
      }
    },
    goodListTitle() {
      if (this.isUsingDevice === "pc") {
        return "良いおこない";
      } else {
        return "良い行い >";
      }
    },
    badListTitle() {
      if (this.isUsingDevice === "pc") {
        return "悪いおこない";
      } else {
        return "< 悪い行い";
      }
    }
  },
  components: {
    TitleLabel,
    CheckListTitle,
    CheckListSwitch,
    CheckList,
    NormalSimpleButton,
    NormalSimpleBlackButton,
    Dialog
  },
  head: {
    title: {
      inner: "check"
    }
  }
};
</script>

<style scoped>
.check_list-area {
  height: 600px;
}
.check_list {
  height: 90%;
}
.switch-text {
  margin: 0;
  padding-top: 15px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.8);
}
</style>
